<template>
  <div class="wrap-lg">
    <div class="boxs-top clearfix">
      <div class="top-title"><span>专题推荐</span></div>
      <div class="top-more">
        <my-link href="/topic" >
          查看更多
          <i class="el-icon-arrow-right"></i>
        </my-link>
      </div>
    </div>
    <div class="top-divider"></div>
    <div class="list-topic">
      <div v-for="topic in topics" :key="topic.id" class="topic-box-item"
           :style="'background-image: url('+ topic.imgUrl +');'">
        <div style="height:170px;">
          <my-link :href="'/topic/detail?sid='+topic.id" target="_blank">
            <div class="box-title">{{topic.title}}</div>
            <div class="box-desc" v-show="topic">{{topic.description}}</div>
          </my-link>
        </div>
        <div class="item-block">
          {{topic.description}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFirst } from '@/api/platform/topic'

export default {
  name: 'recommendTopic',
  data () {
    return {
      topics: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      let param = {}
      getFirst(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData) {
            this.topics = result.bizData
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-topic {
    display: inline-flex;
    margin-top: 20px;
    .topic-box-item {
      width: 290px;
      height: 170px;
      background-repeat: no-repeat;
      background-position: center right;
      background-size: 100%;
      border-radius: 10px;
      &:not(:first-child) {
        margin-left: 23px;
      }
      .box-title {
        text-align: center;
        font-size: 28px;
        font-weight: 500;
        height: 110px;
        line-height: 110px;
        color: #FFFFFF;
      }
      .box-desc {
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        font-weight: 400;
        border-radius: 0 0 10px 10px;
        color: #FFFFFF;
        background-image: -webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,84.7%,0)),to(#3b3b3b));
        background-image: linear-gradient(180deg,hsla(0,0%,84.7%,0),#3b3b3b);
        -webkit-transition: .2s;
        transition: .2s;
      }
      &:hover {
        border-radius: 10px 10px 0 0;
        .box-desc {
          display: none;
        }
        .item-block {
          display: block;
        }
      }
    }
  }

  .item-block {
    display: none;
    position: absolute;
    height: 60px;
    line-height: 60px;
    background-color: #ffffff;
    z-index: 1;
    text-align: center;
    width: 290px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 0 0 10px 10px;
    -webkit-transition: .2s;
    transition: .2s;
  }
</style>
